import { ApiType } from "@gymflow/common";
import { TemplateDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { emailTemplateQueryKeys } from "./emailTemplateQueryKeys";

export function useEmailTemplate(
  {
    api,
    emailTemplateId,
  }: {
    api: ApiType;
    emailTemplateId?: number;
  },
  opts?: Omit<UseQueryOptions<TemplateDTO | null>, "queryKey">,
) {
  return useQuery({
    queryKey: emailTemplateQueryKeys.details(emailTemplateId),
    queryFn: async () => {
      return (await api.emailTemplateApi.findById(emailTemplateId!)).data;
    },
    enabled: !!emailTemplateId,
    ...opts,
  });
}
